import { singUpGetters } from "./signup/index";
import { countryCodeGetters } from "./countryCodes";
import { authGetters } from "./auth";
import { businessTypeGetters } from "./businessType";
import { trainingGroupGetters } from "./trainingGroup";
import { shopcardGetters } from "./shopCard";
import { templateGetters } from "./template";
import { memberGetters } from "./member";
import { userCamDigitGetters } from "./confirmAccount";
export default {
  ...singUpGetters,
  ...countryCodeGetters,
  ...authGetters,
  ...businessTypeGetters,
  ...trainingGroupGetters,
  ...shopcardGetters,
  ...templateGetters,
  ...memberGetters,
  ...userCamDigitGetters
};
